// extracted by mini-css-extract-plugin
export default {"catalog":"UserCatalogContainer_catalog__YXDwz"};